import { useAuth } from "../../context/AuthContext";
import CrudManager from "../../components/admin/CrudManager";
import { PageHeader } from "../../components/admin/ui";
import { humanize } from "../../lib/format";

const FIELDS = [
  { name: "name", label: "Name" }, { name: "email", label: "Email" },
  { name: "role", label: "Role", type: "select", options: [{ value: "super_admin", label: "Super Admin" }, { value: "editor", label: "Editor" }, { value: "viewer", label: "Viewer" }, { value: "sag_finance", label: "SAG Finance (Sebastian Alliance Group)" }] },
  { name: "can_publish", label: "Can publish (Editors)", type: "switch" }, { name: "can_manage_payments", label: "Can manage payments: check receipts, void, verify (Editors)", type: "switch" }, { name: "can_manage_finance", label: "Finance: SAG Processing Fees (Editors)", type: "switch" }, { name: "active", label: "Active", type: "switch" },
  { name: "password", label: "Password (leave blank to keep)", type: "password", help: "Minimum 8 characters." },
];

export default function Users() {
  const { user } = useAuth();
  return (
    <div data-testid="admin-users">
      <PageHeader title="Settings / Users" subtitle="Roles: Super Admin (everything incl. users & publish), Editor (edit; publish only if permitted), Viewer (read-only)." />
      {user.role !== "super_admin" ? <p className="admin-card" data-testid="users-forbidden">Only Super Admins can manage users. Site-wide settings live under Website Content → Global Settings.</p> : (
        <CrudManager endpoint="/admin/users" title="Users" testid="users-crud" fields={FIELDS} canWrite defaults={{ role: "editor", can_publish: false, active: true }}
          columns={[{ key: "name", label: "Name" }, { key: "email", label: "Email" }, { key: "role", label: "Role", render: (r) => humanize(r.role) },
            { key: "p", label: "Publish", render: (r) => (r.role === "super_admin" || r.can_publish ? "Yes" : "No") }, { key: "a", label: "Active", render: (r) => (r.active === false ? "No" : "Yes") }]} />
      )}
    </div>
  );
}
